import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-46ce9ab7")

_pushScopeId("data-v-46ce9ab7")
const _hoisted_1 = { class: "info-item-bottom" }
const _hoisted_2 = { class: "info-item-bottom font-weight600" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_4 = { class: "info-item-bottom" }
const _hoisted_5 = { class: "info-item-bottom font-weight600" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_7 = { class: "info-item-bottom" }
const _hoisted_8 = { class: "info-item-bottom font-weight600" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_10 = { class: "info-item-bottom" }
const _hoisted_11 = { class: "info-item-bottom font-weight600" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_13 = { class: "info-item-bottom" }
const _hoisted_14 = { class: "info-item-bottom font-weight600" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_dialog_shell, {
      footerType: "customize",
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
      title: _ctx.$wordList.TabelMessageBoxTitleDetail
    }, {
      footer: _withId(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
          ]),
          _: 1
        })
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("p", _hoisted_2, _toDisplayString(_ctx.$wordList.TabelMessageBoxMessageTitle), 1),
          _createVNode("p", null, _toDisplayString(_ctx.initForm.Title), 1)
        ]),
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$wordList.TabelMessageBoxReceiveType), 1),
          _createVNode("p", null, _toDisplayString(_ctx.initForm.Type), 1)
        ]),
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode("p", _hoisted_8, _toDisplayString(_ctx.$wordList.TabelMessageBoxMessage), 1),
          _createVNode("p", null, _toDisplayString(_ctx.initForm.Message), 1)
        ]),
        _hoisted_9,
        _createVNode("div", _hoisted_10, [
          _createVNode("p", _hoisted_11, _toDisplayString(_ctx.$wordList.TabelMessageBoxReceiver), 1),
          _createVNode("p", null, _toDisplayString(_ctx.initForm.NickNames), 1)
        ]),
        _hoisted_12,
        _createVNode("div", _hoisted_13, [
          _createVNode("p", _hoisted_14, _toDisplayString(_ctx.$wordList.TabelMessageBoxCreateTime), 1),
          _createVNode("p", null, _toDisplayString(_ctx.initForm.CreateTime), 1)
        ]),
        _hoisted_15
      ]),
      _: 1
    }, 8, ["title"])
  ]))
})